const notice = {
  notificationType: "Notification type",
  notificationType1: "Security mode alarm",
  notificationType3: "Safety reminder",
  notificationType4: "Geo fence reminder",
  notificationType5: "Offline/Online alarm",
  notificationType6: "Activity remainder",
  notificationType7: "System message",
  notificationType8: "Over speed reminder",
  notificationType9: "Trip report",
  isdisabled: "Account status",
  title: "Title",
  content: "Content",
  pushOrNot: "Push Status",
  readOrNot: "Read Status",
  search: {
    width1: "80px",
    width2: "80px",
    width3: "100px",
    width4: "100px"
  },
  yes: "Yes",
  no: "No",
  dialog: {
    pushTitle: "Push title",
    pushContent: "Push content",
    selectUsers: "Select users",
    pushAll: "Push all users or not",
    noTitle: "Please enter a title",
    noContent: "Please enter content",
    noUser: "Please select users",
    labelWidth: "140px"
  },
  user: {
    loginName: "Login name",
    disableOrNot: "Disable or not"
  }
} 
export default notice